import { render, staticRenderFns } from "./TeacherInfoCard.vue?vue&type=template&id=b983a112&"
import script from "./TeacherInfoCard.vue?vue&type=script&lang=js&"
export * from "./TeacherInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports